import { useId } from 'react'

// Types
import type { CircleShapeProps } from '@/types/components/atoms/shapes/circle'

const CircleShapeAtom = (props: CircleShapeProps) => {
	// Props
	const { color } = props

	// Variables
	const id = useId()

	return (
		<svg width={581} height={581} viewBox="0 0 581 581" fill="none">
			<defs>
				<filter id={id} x={0} y={0} width={581} height={581} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_1_144" />
				</filter>
			</defs>

			<g filter={`url(#${id})`}>
				<circle cx={290.5} cy={290.5} r={190.5} fill={color} />
			</g>
		</svg>
	)
}

export default CircleShapeAtom
